import { useMemo } from "react";

import { getEPlanNavigateToPaymentAutomation } from "../../util/encampy/ePlanNavigateToPayment";
import {
  EncampyAutomationLauncher,
  EncampyAutomationLauncherProps,
  EncampyLaunchData,
} from "./AutomationLauncher";

export interface EncampyEPlanPaymentLauncherProps extends Omit<
  EncampyAutomationLauncherProps,
  "launchData"
> {
  username: string;
  password: string;
  reportingYear: number;
  portalReportId?: string;
}

export function EncampyEPlanPaymentLauncher({
  username,
  password,
  reportingYear,
  portalReportId,
  buttonText = "Open Payment with Encampy",
  disabled = false,
  disabledReason,
  ...rest
}: EncampyEPlanPaymentLauncherProps) {
  const launchData = useMemo((): EncampyLaunchData | null => {
    if (!portalReportId) {
      return null;
    }
    return {
      url: "https://tier2.erplan.net",
      automation: getEPlanNavigateToPaymentAutomation(
        username,
        password,
        reportingYear,
        portalReportId
      ),
    };
  }, [username, password, reportingYear, portalReportId]);

  const computedDisabledReason = useMemo((): string | undefined => {
    if (disabled && disabledReason) {
      return disabledReason;
    }
    if (!launchData) {
      return "The portal report ID is required";
    }
    if (disabled) {
      return "The payment navigation is disabled";
    }
    return undefined;
  }, [launchData, disabled, disabledReason]);

  // If no launch data, provide a placeholder to show disabled state
  const effectiveLaunchData: EncampyLaunchData = launchData ?? {
    url: "https://tier2.erplan.net",
    automation: async () => {
      // No-op automation for disabled state
    },
  };

  return (
    <EncampyAutomationLauncher
      launchData={effectiveLaunchData}
      buttonText={buttonText}
      disabled={disabled || !launchData}
      disabledReason={computedDisabledReason}
      {...rest}
    />
  );
}
